import React, { Component } from "react";
import {
  Button,
  Container,
  Row, Form,
  Col,
  Offcanvas,
} from "react-bootstrap";
import { toast } from "react-toastify";
import DataTable from "react-data-table-component";
import configData from '../config.json';

import LoadingOverlay from "./LoadingOverlay";
export default class Bill extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: false,
      loadingMessage: "Processing your request...",
      show: false,
      data: [],
      sId: sessionStorage.getItem("sessionId"),
      uId: sessionStorage.getItem("uId"),
      errors: {},
      filteredData: null,
      tableClms: [
        {
          name: "S.NO",
          selector: (row, i) => row.bill_Id,
          sortable: true,
          cell: (row) => <span>{row.bill_Id}</span>,
        },
        { name: "Bill Id", selector: (row, i) => row.billId, sortable: true, cell: (row) => <span>{row.billId}</span>, }, { name: "Member Id", selector: (row, i) => row.memberId, sortable: true, cell: (row) => <span>{row.memberId}</span>, }, { name: "Bill No", selector: (row, i) => row.billNo, sortable: true, cell: (row) => <span>{row.billNo}</span>, }, { name: "Charge Type", selector: (row, i) => row.chargeType, sortable: true, cell: (row) => <span>{row.chargeType}</span>, }, { name: "Quantity", selector: (row, i) => row.quantity, sortable: true, cell: (row) => <span>{row.quantity}</span>, }, { name: "Price", selector: (row, i) => row.price, sortable: true, cell: (row) => <span>{row.price}</span>, }, { name: "Amount", selector: (row, i) => row.amount, sortable: true, cell: (row) => <span>{row.amount}</span>, }, { name: "Bill Date", selector: (row, i) => row.billDate, sortable: true, cell: (row) => <span>{row.billDate}</span>, }, { name: "Claim Id", selector: (row, i) => row.claimId, sortable: true, cell: (row) => <span>{row.claimId}</span>, }, { name: "Sanction Amount", selector: (row, i) => row.sanctionAmount, sortable: true, cell: (row) => <span>{row.sanctionAmount}</span>, }, { name: "Disallowed Amount", selector: (row, i) => row.disallowedAmount, sortable: true, cell: (row) => <span>{row.disallowedAmount}</span>, }, { name: "Disallowance Reason", selector: (row, i) => row.disallowanceReason, sortable: true, cell: (row) => <span>{row.disallowanceReason}</span>, }, { name: "BillDoc ID", selector: (row, i) => row.billdocid, sortable: true, cell: (row) => <span>{row.billdocid}</span>, }, { name: "Dummy One", selector: (row, i) => row.dummyOne, sortable: true, cell: (row) => <span>{row.dummyOne}</span>, }, { name: "Dummy Two", selector: (row, i) => row.dummyTwo, sortable: true, cell: (row) => <span>{row.dummyTwo}</span>, }, { name: "Dummy Three", selector: (row, i) => row.dummyThree, sortable: true, cell: (row) => <span>{row.dummyThree}</span>, }, { name: "Dummy Four", selector: (row, i) => row.dummyFour, sortable: true, cell: (row) => <span>{row.dummyFour}</span>, }, { name: "Dummy Five ", selector: (row, i) => row.dummyFive, sortable: true, cell: (row) => <span>{row.dummyFive}</span>, },
        //***tableClms
        {
          name: "Actions",
          sortable: false,
          cell: (row) => (
            <div>
              {/* edit button and delete button */}
              <Button
                style={{ marginRight: "10px" }}
                variant="primary"
                onClick={() => this.BilleditHandler(row)}
                className="bi bi-pen"
              >
              </Button>
              <Button
                variant="danger"
                onClick={() => this.handleDelete(row)}
                className="bi bi-trash danger"
              >
              </Button>
            </div>
          ),
        },
      ],
      currentPage: 1,
      itemsPerPage: 10,
      isEditing: false,
      bill_Id: "",
      billId: '', memberId: '', billNo: '', chargeType: '', quantity: '', price: '', amount: '', billDate: '', claimId: '', sanctionAmount: '', disallowedAmount: '', disallowanceReason: '', billdocid: '', dummyOne: '', dummyTwo: '', dummyThree: '', dummyFour: '', dummyFive: '',
      //***state
    };
  }
  // offcanvas Open
  handleOffcanvasShow = () => {
    this.setState({ show: true, billId: '', memberId: '', billNo: '', chargeType: '', quantity: '', price: '', amount: '', billDate: '', claimId: '', sanctionAmount: '', disallowedAmount: '', disallowanceReason: '', billdocid: '', dummyOne: '', dummyTwo: '', dummyThree: '', dummyFour: '', dummyFive: '', });
  };
  // Offcanvas close button
  handleOffcanvasClose = () => {
    this.setState({ show: false, isEditing: false, billId: '', memberId: '', billNo: '', chargeType: '', quantity: '', price: '', amount: '', billDate: '', claimId: '', sanctionAmount: '', disallowedAmount: '', disallowanceReason: '', billdocid: '', dummyOne: '', dummyTwo: '', dummyThree: '', dummyFour: '', dummyFive: '', });
  };
  showToast = (msg, type) => {
    switch (type) {
      case "success":
        toast.success(msg);
        break;
      case "error":
        toast.error(msg);
        break;
      case "warning":
        toast.warn(msg); // 'warn' is used instead of 'warning'
        break;
      default:
        toast.info(msg);
    }
  };
  BilleditHandler = (row) => {
    // e.preventDefault();
    this.setState({
      isEditing: true, bill_Id: row.bill_Id, billId: row.billId, memberId: row.memberId, billNo: row.billNo, chargeType: row.chargeType, quantity: row.quantity, price: row.price, amount: row.amount, billDate: row.billDate, claimId: row.claimId, sanctionAmount: row.sanctionAmount, disallowedAmount: row.disallowedAmount, disallowanceReason: row.disallowanceReason, billdocid: row.billdocid, dummyOne: row.dummyOne, dummyTwo: row.dummyTwo, dummyThree: row.dummyThree, dummyFour: row.dummyFour, dummyFive: row.dummyFive, //***editstate
    });
  }

  BillfetchHandler = () => {
    var formData = new FormData();
    formData.append("sId", this.state.sId);
    formData.append("uId", this.state.uId);
    fetch(configData.api_url + 'C_Bill/list', {  // Enter your IP address here

      method: 'POST',
      //headers :{ 'Content-Type' : 'application/json'},
      mode: 'cors',
      body: formData// body data type must match "Content-Type" header
    }).then(response => response.json())
      .then((data) => {
        if (data.status === "success") {
          this.setState({ data: data.list });
        }
      });
  }
  BillsubmitHandler = (e) => {
    e.preventDefault();
    //   setButtons(contacts);
    var formData = new FormData();
    formData.append("sId", this.state.sId);
    formData.append("uId", this.state.uId);
    formData.append('billId', this.state.billId);
    formData.append('memberId', this.state.memberId);
    formData.append('billNo', this.state.billNo);
    formData.append('chargeType', this.state.chargeType);
    formData.append('quantity', this.state.quantity);
    formData.append('price', this.state.price);
    formData.append('amount', this.state.amount);
    formData.append('billDate', this.state.billDate);
    formData.append('claimId', this.state.claimId);
    formData.append('sanctionAmount', this.state.sanctionAmount);
    formData.append('disallowedAmount', this.state.disallowedAmount);
    formData.append('disallowanceReason', this.state.disallowanceReason);
    formData.append('billdocid', this.state.billdocid);
    formData.append('dummyOne', this.state.dummyOne);
    formData.append('dummyTwo', this.state.dummyTwo);
    formData.append('dummyThree', this.state.dummyThree);
    formData.append('dummyFour', this.state.dummyFour);
    formData.append('dummyFive', this.state.dummyFive);

    //***tableData*
    this.setState({ loading: true, loadingMessage: "Saving..." });
    fetch(configData.api_url + 'C_Bill/add', {  // Enter your IP address here

      method: 'POST',
      //headers :{ 'Content-Type' : 'application/json'},
      mode: 'cors',
      body: formData// body data type must match "Content-Type" header
    }).then(response => response.json())
      .then((data) => {
        this.showToast(data.message, data.status);
        if (data.status === "success") {
          this.BillfetchHandler();
          this.handleOffcanvasClose();
          this.setState({ billId: '', memberId: '', billNo: '', chargeType: '', quantity: '', price: '', amount: '', billDate: '', claimId: '', sanctionAmount: '', disallowedAmount: '', disallowanceReason: '', billdocid: '', dummyOne: '', dummyTwo: '', dummyThree: '', dummyFour: '', dummyFive: '', });
        }
      
        this.setState({ loading: false });})
    .catch(() => { this.setState({ loading: false }); });
  }
  BillupdateHandler = (e) => {
    e.preventDefault();
    var formData = new FormData();
    formData.append("sId", this.state.sId);
    formData.append("uId", this.state.uId);
    formData.append("bill_Id", this.state.bill_Id);
    formData.append('billId', this.state.billId);
    formData.append('memberId', this.state.memberId);
    formData.append('billNo', this.state.billNo);
    formData.append('chargeType', this.state.chargeType);
    formData.append('quantity', this.state.quantity);
    formData.append('price', this.state.price);
    formData.append('amount', this.state.amount);
    formData.append('billDate', this.state.billDate);
    formData.append('claimId', this.state.claimId);
    formData.append('sanctionAmount', this.state.sanctionAmount);
    formData.append('disallowedAmount', this.state.disallowedAmount);
    formData.append('disallowanceReason', this.state.disallowanceReason);
    formData.append('billdocid', this.state.billdocid);
    formData.append('dummyOne', this.state.dummyOne);
    formData.append('dummyTwo', this.state.dummyTwo);
    formData.append('dummyThree', this.state.dummyThree);
    formData.append('dummyFour', this.state.dummyFour);
    formData.append('dummyFive', this.state.dummyFive);

    //***tableData1
    this.setState({ loading: true, loadingMessage: "Updating..." });
    fetch(configData.api_url + 'C_Bill/update', {
      method: 'POST',
      mode: 'cors',
      body: formData
    }).then(response => response.json())
      .then((data) => {
        this.showToast(data.message, data.status);
        if (data.status === "success") {
          this.BillfetchHandler();
          this.handleOffcanvasClose();
        }
      
        this.setState({ loading: false });})
    .catch(() => { this.setState({ loading: false }); });
  }

  componentDidMount() {
    this.BillfetchHandler();

    //***componentDidMount
  }
  handlebillIdChange = (e) => {
    e.preventDefault();
    const fieldValue = e.target.value;
    this.setState({ billId: fieldValue });
  }; handlememberIdChange = (e) => {
    e.preventDefault();
    const fieldValue = e.target.value;
    this.setState({ memberId: fieldValue });
  }; handlebillNoChange = (e) => {
    e.preventDefault();
    const fieldValue = e.target.value;
    this.setState({ billNo: fieldValue });
  }; handlechargeTypeChange = (e) => {
    e.preventDefault();
    const fieldValue = e.target.value;
    this.setState({ chargeType: fieldValue });
  }; handlequantityChange = (e) => {
    e.preventDefault();
    const fieldValue = e.target.value;
    this.setState({ quantity: fieldValue });
  }; handlepriceChange = (e) => {
    e.preventDefault();
    const fieldValue = e.target.value;
    this.setState({ price: fieldValue });
  }; handleamountChange = (e) => {
    e.preventDefault();
    const fieldValue = e.target.value;
    this.setState({ amount: fieldValue });
  }; handlebillDateChange = (e) => {
    e.preventDefault();

    const fieldValue = e.target.value;
    this.setState({ billDate: fieldValue });
  }; handleclaimIdChange = (e) => {
    e.preventDefault();
    const fieldValue = e.target.value;
    this.setState({ claimId: fieldValue });
  }; handlesanctionAmountChange = (e) => {
    e.preventDefault();
    const fieldValue = e.target.value;
    this.setState({ sanctionAmount: fieldValue });
  }; handledisallowedAmountChange = (e) => {
    e.preventDefault();
    const fieldValue = e.target.value;
    this.setState({ disallowedAmount: fieldValue });
  }; handledisallowanceReasonChange = (e) => {
    e.preventDefault();
    const fieldValue = e.target.value;
    this.setState({ disallowanceReason: fieldValue });
  }; handlebilldocidChange = (e) => {
    e.preventDefault();
    const fieldValue = e.target.value;
    this.setState({ billdocid: fieldValue });
  }; handledummyOneChange = (e) => {
    e.preventDefault();
    const fieldValue = e.target.value;
    this.setState({ dummyOne: fieldValue });
  }; handledummyTwoChange = (e) => {
    e.preventDefault();
    const fieldValue = e.target.value;
    this.setState({ dummyTwo: fieldValue });
  }; handledummyThreeChange = (e) => {
    e.preventDefault();
    const fieldValue = e.target.value;
    this.setState({ dummyThree: fieldValue });
  }; handledummyFourChange = (e) => {
    e.preventDefault();
    const fieldValue = e.target.value;
    this.setState({ dummyFour: fieldValue });
  }; handledummyFiveChange = (e) => {
    e.preventDefault();
    const fieldValue = e.target.value;
    this.setState({ dummyFive: fieldValue });
  };
  //***inputFunctions
  handleRowSelect = (row) => {
    this.setState({
      selectedRow: row.index,
    });
  };
  handleRowUpdate = (newData, oldData) => {
    const data = [...this.state.data];
    const index = oldData.index;
    data[index] = newData;
    this.setState({ data });
  };

  handleEdit = (row) => {
    console.log(`Editing row with ID ${row.id}`);
    // implement your edit logic here
  };
  handleDelete = (row, index) => {
    var formData = new FormData();
    formData.append('bill_Id', row.bill_Id);
    this.setState({ loading: true, loadingMessage: "Deleting..." });
    fetch(configData.api_url + 'C_Bill/delete', {
      method: 'POST',
      mode: 'cors',
      body: formData
    }).then(response => response.json())
      .then((data) => {
        this.showToast(data.message, data.status);
        if (data.status === "success") {
          this.BillfetchHandler();
        }
      
        this.setState({ loading: false });})
    .catch(() => { this.setState({ loading: false }); });
  };
  handlePageChange = (page) => {
    this.setState({ currentPage: page });
  };

  handlePerRowsChange = (newPerPage, page) => {
    this.setState({ itemsPerPage: newPerPage, currentPage: page });
  };

  handleFilter = (e) => {
    const searchValue = e.target.value.toLowerCase();
    const filteredData = this.state.data.filter((row) => {
      return Object.values(row).join(" ").toLowerCase().includes(searchValue);
    });
    this.setState({ filteredData });
  };

  render() {
    const paginatedData = this.state.filteredData
      ? this.state.filteredData.slice(
        (this.state.currentPage - 1) * this.state.itemsPerPage,
        this.state.currentPage * this.state.itemsPerPage
      )
      : this.state.data.slice(
        (this.state.currentPage - 1) * this.state.itemsPerPage,
        this.state.currentPage * this.state.itemsPerPage
      );

    return (
      <div className="page-title">
        <LoadingOverlay show={this.state.loading} message={this.state.loadingMessage} />
        <div className="row">
          <div className="col-md-12 col-sm-12 col-xs-12">
            <div className="x_panel">
              <div className="x_content">
                <div
                  id="datatable_wrapper"
                  className="dataTables_wrapper form-inline
                dt-bootstrap no-footer"
                >
                  <Row className="row">
                    <div>
                      <h3 className="logoskybluecolor" style={{ textAlign: "start" }}>Bill</h3>
                    </div>
                    <Col
                      className="d-flex justify-content-end"
                      style={{ marginRight: "5px", marginTop: "20px" }}
                    >
                      <Button
                        variant="primary" style={{ float: "right", marginBottom: "10px" }}
                        className="bi bi-plus "
                        onClick={this.handleOffcanvasShow}
                      >
                        New
                      </Button>
                      <Offcanvas
                        show={this.state.show}
                        onHide={this.handleOffcanvasClose}
                        {...this.props}
                        style={{ width: "500px" }}
                        placement="end"
                        backdrop="true"
                      >
                        <Offcanvas.Header closeButton>
                          <Offcanvas.Title>Add Bill</Offcanvas.Title>
                        </Offcanvas.Header>
                        <Offcanvas.Body>
                          <Container style={{ "overflowY": "auto", height: "auto" }}>
                            <Row className="divstyle">
                              <Row>
                                <Form>
                                  <Row>
                                    <Col lg="4" md="4">
                                      <Form.Label style={{ paddingTop: "8px" }}>Bill Id</Form.Label>
                                    </Col>
                                    <Col lg="8" md="8">
                                      <Form.Control type="text" onChange={this.handlebillIdChange} className="form-control" name="billId" value={this.state.billId} required="required" placeholder="Enter Bill Id" />
                                    </Col>
                                    <div className="errorMsg" style={{ color: "red" }}> {this.state.errors.billId} </div>
                                  </Row><br /><Row>
                                    <Col lg="4" md="4">
                                      <Form.Label style={{ paddingTop: "8px" }}>Member Id</Form.Label>
                                    </Col>
                                    <Col lg="8" md="8">
                                      <Form.Control type="text" onChange={this.handlememberIdChange} className="form-control" name="memberId" value={this.state.memberId} required="required" placeholder="Enter Member Id" />
                                    </Col>
                                    <div className="errorMsg" style={{ color: "red" }}> {this.state.errors.memberId} </div>
                                  </Row><br /><Row>
                                    <Col lg="4" md="4">
                                      <Form.Label style={{ paddingTop: "8px" }}>Bill No</Form.Label>
                                    </Col>
                                    <Col lg="8" md="8">
                                      <Form.Control type="text" onChange={this.handlebillNoChange} className="form-control" name="billNo" value={this.state.billNo} required="required" placeholder="Enter Bill No" />
                                    </Col>
                                    <div className="errorMsg" style={{ color: "red" }}> {this.state.errors.billNo} </div>
                                  </Row><br /><Row>
                                    <Col lg="4" md="4">
                                      <Form.Label style={{ paddingTop: "8px" }}>Charge Type</Form.Label>
                                    </Col>
                                    <Col lg="8" md="8">
                                      <Form.Control type="text" onChange={this.handlechargeTypeChange} className="form-control" name="chargeType" value={this.state.chargeType} required="required" placeholder="Enter Charge Type" />
                                    </Col>
                                    <div className="errorMsg" style={{ color: "red" }}> {this.state.errors.chargeType} </div>
                                  </Row><br /><Row>
                                    <Col lg="4" md="4">
                                      <Form.Label style={{ paddingTop: "8px" }}>Quantity</Form.Label>
                                    </Col>
                                    <Col lg="8" md="8">
                                      <Form.Control type="text" onChange={this.handlequantityChange} className="form-control" name="quantity" value={this.state.quantity} required="required" placeholder="Enter Quantity" />
                                    </Col>
                                    <div className="errorMsg" style={{ color: "red" }}> {this.state.errors.quantity} </div>
                                  </Row><br /><Row>
                                    <Col lg="4" md="4">
                                      <Form.Label style={{ paddingTop: "8px" }}>Price</Form.Label>
                                    </Col>
                                    <Col lg="8" md="8">
                                      <Form.Control type="text" onChange={this.handlepriceChange} className="form-control" name="price" value={this.state.price} required="required" placeholder="Enter Price" />
                                    </Col>
                                    <div className="errorMsg" style={{ color: "red" }}> {this.state.errors.price} </div>
                                  </Row><br /><Row>
                                    <Col lg="4" md="4">
                                      <Form.Label style={{ paddingTop: "8px" }}>Amount</Form.Label>
                                    </Col>
                                    <Col lg="8" md="8">
                                      <Form.Control type="text" onChange={this.handleamountChange} className="form-control" name="amount" value={this.state.amount} required="required" placeholder="Enter Amount" />
                                    </Col>
                                    <div className="errorMsg" style={{ color: "red" }}> {this.state.errors.amount} </div>
                                  </Row><br /><Row>
                                    <Col lg="4" md="4">
                                      <Form.Label style={{ paddingTop: "8px" }}>Bill Date</Form.Label>
                                    </Col>
                                    <Col lg="8" md="8">
                                      <Form.Control type="date" onChange={this.handlebillDateChange} className="form-control" name="billDate" value={this.state.billDate} required="required" placeholder="Enter Bill Date" />
                                    </Col>
                                    <div className="errorMsg" style={{ color: "red" }}> {this.state.errors.billDate} </div>
                                  </Row><br /><Row>
                                    <Col lg="4" md="4">
                                      <Form.Label style={{ paddingTop: "8px" }}>Claim Id</Form.Label>
                                    </Col>
                                    <Col lg="8" md="8">
                                      <Form.Control type="text" onChange={this.handleclaimIdChange} className="form-control" name="claimId" value={this.state.claimId} required="required" placeholder="Enter Claim Id" />
                                    </Col>
                                    <div className="errorMsg" style={{ color: "red" }}> {this.state.errors.claimId} </div>
                                  </Row><br /><Row>
                                    <Col lg="4" md="4">
                                      <Form.Label style={{ paddingTop: "8px" }}>Sanction Amount</Form.Label>
                                    </Col>
                                    <Col lg="8" md="8">
                                      <Form.Control type="text" onChange={this.handlesanctionAmountChange} className="form-control" name="sanctionAmount" value={this.state.sanctionAmount} required="required" placeholder="Enter Sanction Amount" />
                                    </Col>
                                    <div className="errorMsg" style={{ color: "red" }}> {this.state.errors.sanctionAmount} </div>
                                  </Row><br /><Row>
                                    <Col lg="4" md="4">
                                      <Form.Label style={{ paddingTop: "8px" }}>Disallowed Amount</Form.Label>
                                    </Col>
                                    <Col lg="8" md="8">
                                      <Form.Control type="text" onChange={this.handledisallowedAmountChange} className="form-control" name="disallowedAmount" value={this.state.disallowedAmount} required="required" placeholder="Enter Disallowed Amount" />
                                    </Col>
                                    <div className="errorMsg" style={{ color: "red" }}> {this.state.errors.disallowedAmount} </div>
                                  </Row><br /><Row>
                                    <Col lg="4" md="4">
                                      <Form.Label style={{ paddingTop: "8px" }}>Disallowance Reason</Form.Label>
                                    </Col>
                                    <Col lg="8" md="8">
                                      <Form.Control type="text" onChange={this.handledisallowanceReasonChange} className="form-control" name="disallowanceReason" value={this.state.disallowanceReason} required="required" placeholder="Enter Disallowance Reason" />
                                    </Col>
                                    <div className="errorMsg" style={{ color: "red" }}> {this.state.errors.disallowanceReason} </div>
                                  </Row><br /><Row>
                                    <Col lg="4" md="4">
                                      <Form.Label style={{ paddingTop: "8px" }}>BillDoc ID</Form.Label>
                                    </Col>
                                    <Col lg="8" md="8">
                                      <Form.Control type="text" onChange={this.handlebilldocidChange} className="form-control" name="billdocid" value={this.state.billdocid} required="required" placeholder="Enter BillDoc ID" />
                                    </Col>
                                    <div className="errorMsg" style={{ color: "red" }}> {this.state.errors.billdocid} </div>
                                  </Row><br /><Row>
                                    <Col lg="4" md="4">
                                      <Form.Label style={{ paddingTop: "8px" }}>Dummy One</Form.Label>
                                    </Col>
                                    <Col lg="8" md="8">
                                      <Form.Control type="text" onChange={this.handledummyOneChange} className="form-control" name="dummyOne" value={this.state.dummyOne} required="required" placeholder="Enter Dummy One" />
                                    </Col>
                                    <div className="errorMsg" style={{ color: "red" }}> {this.state.errors.dummyOne} </div>
                                  </Row><br /><Row>
                                    <Col lg="4" md="4">
                                      <Form.Label style={{ paddingTop: "8px" }}>Dummy Two</Form.Label>
                                    </Col>
                                    <Col lg="8" md="8">
                                      <Form.Control type="text" onChange={this.handledummyTwoChange} className="form-control" name="dummyTwo" value={this.state.dummyTwo} required="required" placeholder="Enter Dummy Two" />
                                    </Col>
                                    <div className="errorMsg" style={{ color: "red" }}> {this.state.errors.dummyTwo} </div>
                                  </Row><br /><Row>
                                    <Col lg="4" md="4">
                                      <Form.Label style={{ paddingTop: "8px" }}>Dummy Three</Form.Label>
                                    </Col>
                                    <Col lg="8" md="8">
                                      <Form.Control type="text" onChange={this.handledummyThreeChange} className="form-control" name="dummyThree" value={this.state.dummyThree} required="required" placeholder="Enter Dummy Three" />
                                    </Col>
                                    <div className="errorMsg" style={{ color: "red" }}> {this.state.errors.dummyThree} </div>
                                  </Row><br /><Row>
                                    <Col lg="4" md="4">
                                      <Form.Label style={{ paddingTop: "8px" }}>Dummy Four</Form.Label>
                                    </Col>
                                    <Col lg="8" md="8">
                                      <Form.Control type="text" onChange={this.handledummyFourChange} className="form-control" name="dummyFour" value={this.state.dummyFour} required="required" placeholder="Enter Dummy Four" />
                                    </Col>
                                    <div className="errorMsg" style={{ color: "red" }}> {this.state.errors.dummyFour} </div>
                                  </Row><br /><Row>
                                    <Col lg="4" md="4">
                                      <Form.Label style={{ paddingTop: "8px" }}>Dummy Five </Form.Label>
                                    </Col>
                                    <Col lg="8" md="8">
                                      <Form.Control type="text" onChange={this.handledummyFiveChange} className="form-control" name="dummyFive" value={this.state.dummyFive} required="required" placeholder="Enter Dummy Five " />
                                    </Col>
                                    <div className="errorMsg" style={{ color: "red" }}> {this.state.errors.dummyFive} </div>
                                  </Row><br />
                                  {/* tableContent */}
                                </Form>
                              </Row>
                            </Row>
                            <Row>
                              <Col
                                className="d-flex justify-content-end"
                                style={{ marginRight: "50px" }}
                              >
                                <Button
                                  className="button"
                                  variant="success"
                                  onClick={this.BillsubmitHandler}
                                  style={{
                                    marginTop: "20px",
                                  }}
                                >
                                  Save
                                </Button>
                              </Col>
                            </Row>
                          </Container>
                        </Offcanvas.Body>
                      </Offcanvas>
                      {this.state.isEditing && (
                        // Edit Offcanvas
                        <Offcanvas
                          show={this.state.isEditing}
                          // onHide={() => this.setState({ isEditing: false })}
                          onHide={this.handleOffcanvasClose}
                          {...this.props}
                          style={{ width: "500px" }}
                          placement="end"
                          backdrop="true"
                        >
                          <Offcanvas.Header closeButton>
                            <Offcanvas.Title>Edit Bill</Offcanvas.Title>
                          </Offcanvas.Header>
                          <Offcanvas.Body>
                            <Container style={{ "overflowY": "auto", height: "auto" }}>
                              <Row className="divstyle">
                                <Row>
                                  <Form>
                                    <Row>
                                      <Col lg="4" md="4">
                                        <Form.Label style={{ paddingTop: "8px" }}>Bill Id</Form.Label>
                                      </Col>
                                      <Col lg="8" md="8">
                                        <Form.Control type="text" onChange={this.handlebillIdChange} className="form-control" name="billId" value={this.state.billId} required="required" placeholder="Enter Bill Id" />
                                      </Col>
                                      <div className="errorMsg" style={{ color: "red" }}> {this.state.errors.billId} </div>
                                    </Row><br /><Row>
                                      <Col lg="4" md="4">
                                        <Form.Label style={{ paddingTop: "8px" }}>Member Id</Form.Label>
                                      </Col>
                                      <Col lg="8" md="8">
                                        <Form.Control type="text" onChange={this.handlememberIdChange} className="form-control" name="memberId" value={this.state.memberId} required="required" placeholder="Enter Member Id" />
                                      </Col>
                                      <div className="errorMsg" style={{ color: "red" }}> {this.state.errors.memberId} </div>
                                    </Row><br /><Row>
                                      <Col lg="4" md="4">
                                        <Form.Label style={{ paddingTop: "8px" }}>Bill No</Form.Label>
                                      </Col>
                                      <Col lg="8" md="8">
                                        <Form.Control type="text" onChange={this.handlebillNoChange} className="form-control" name="billNo" value={this.state.billNo} required="required" placeholder="Enter Bill No" />
                                      </Col>
                                      <div className="errorMsg" style={{ color: "red" }}> {this.state.errors.billNo} </div>
                                    </Row><br /><Row>
                                      <Col lg="4" md="4">
                                        <Form.Label style={{ paddingTop: "8px" }}>Charge Type</Form.Label>
                                      </Col>
                                      <Col lg="8" md="8">
                                        <Form.Control type="text" onChange={this.handlechargeTypeChange} className="form-control" name="chargeType" value={this.state.chargeType} required="required" placeholder="Enter Charge Type" />
                                      </Col>
                                      <div className="errorMsg" style={{ color: "red" }}> {this.state.errors.chargeType} </div>
                                    </Row><br /><Row>
                                      <Col lg="4" md="4">
                                        <Form.Label style={{ paddingTop: "8px" }}>Quantity</Form.Label>
                                      </Col>
                                      <Col lg="8" md="8">
                                        <Form.Control type="text" onChange={this.handlequantityChange} className="form-control" name="quantity" value={this.state.quantity} required="required" placeholder="Enter Quantity" />
                                      </Col>
                                      <div className="errorMsg" style={{ color: "red" }}> {this.state.errors.quantity} </div>
                                    </Row><br /><Row>
                                      <Col lg="4" md="4">
                                        <Form.Label style={{ paddingTop: "8px" }}>Price</Form.Label>
                                      </Col>
                                      <Col lg="8" md="8">
                                        <Form.Control type="text" onChange={this.handlepriceChange} className="form-control" name="price" value={this.state.price} required="required" placeholder="Enter Price" />
                                      </Col>
                                      <div className="errorMsg" style={{ color: "red" }}> {this.state.errors.price} </div>
                                    </Row><br /><Row>
                                      <Col lg="4" md="4">
                                        <Form.Label style={{ paddingTop: "8px" }}>Amount</Form.Label>
                                      </Col>
                                      <Col lg="8" md="8">
                                        <Form.Control type="text" onChange={this.handleamountChange} className="form-control" name="amount" value={this.state.amount} required="required" placeholder="Enter Amount" />
                                      </Col>
                                      <div className="errorMsg" style={{ color: "red" }}> {this.state.errors.amount} </div>
                                    </Row><br /><Row>
                                      <Col lg="4" md="4">
                                        <Form.Label style={{ paddingTop: "8px" }}>Bill Date</Form.Label>
                                      </Col>
                                      <Col lg="8" md="8">
                                        <Form.Control type="date" onChange={this.handlebillDateChange} className="form-control" name="billDate" value={this.state.billDate} required="required" placeholder="Enter Bill Date" />
                                      </Col>
                                      <div className="errorMsg" style={{ color: "red" }}> {this.state.errors.billDate} </div>
                                    </Row><br /><Row>
                                      <Col lg="4" md="4">
                                        <Form.Label style={{ paddingTop: "8px" }}>Claim Id</Form.Label>
                                      </Col>
                                      <Col lg="8" md="8">
                                        <Form.Control type="text" onChange={this.handleclaimIdChange} className="form-control" name="claimId" value={this.state.claimId} required="required" placeholder="Enter Claim Id" />
                                      </Col>
                                      <div className="errorMsg" style={{ color: "red" }}> {this.state.errors.claimId} </div>
                                    </Row><br /><Row>
                                      <Col lg="4" md="4">
                                        <Form.Label style={{ paddingTop: "8px" }}>Sanction Amount</Form.Label>
                                      </Col>
                                      <Col lg="8" md="8">
                                        <Form.Control type="text" onChange={this.handlesanctionAmountChange} className="form-control" name="sanctionAmount" value={this.state.sanctionAmount} required="required" placeholder="Enter Sanction Amount" />
                                      </Col>
                                      <div className="errorMsg" style={{ color: "red" }}> {this.state.errors.sanctionAmount} </div>
                                    </Row><br /><Row>
                                      <Col lg="4" md="4">
                                        <Form.Label style={{ paddingTop: "8px" }}>Disallowed Amount</Form.Label>
                                      </Col>
                                      <Col lg="8" md="8">
                                        <Form.Control type="text" onChange={this.handledisallowedAmountChange} className="form-control" name="disallowedAmount" value={this.state.disallowedAmount} required="required" placeholder="Enter Disallowed Amount" />
                                      </Col>
                                      <div className="errorMsg" style={{ color: "red" }}> {this.state.errors.disallowedAmount} </div>
                                    </Row><br /><Row>
                                      <Col lg="4" md="4">
                                        <Form.Label style={{ paddingTop: "8px" }}>Disallowance Reason</Form.Label>
                                      </Col>
                                      <Col lg="8" md="8">
                                        <Form.Control type="text" onChange={this.handledisallowanceReasonChange} className="form-control" name="disallowanceReason" value={this.state.disallowanceReason} required="required" placeholder="Enter Disallowance Reason" />
                                      </Col>
                                      <div className="errorMsg" style={{ color: "red" }}> {this.state.errors.disallowanceReason} </div>
                                    </Row><br /><Row>
                                      <Col lg="4" md="4">
                                        <Form.Label style={{ paddingTop: "8px" }}>BillDoc ID</Form.Label>
                                      </Col>
                                      <Col lg="8" md="8">
                                        <Form.Control type="text" onChange={this.handlebilldocidChange} className="form-control" name="billdocid" value={this.state.billdocid} required="required" placeholder="Enter BillDoc ID" />
                                      </Col>
                                      <div className="errorMsg" style={{ color: "red" }}> {this.state.errors.billdocid} </div>
                                    </Row><br /><Row>
                                      <Col lg="4" md="4">
                                        <Form.Label style={{ paddingTop: "8px" }}>Dummy One</Form.Label>
                                      </Col>
                                      <Col lg="8" md="8">
                                        <Form.Control type="text" onChange={this.handledummyOneChange} className="form-control" name="dummyOne" value={this.state.dummyOne} required="required" placeholder="Enter Dummy One" />
                                      </Col>
                                      <div className="errorMsg" style={{ color: "red" }}> {this.state.errors.dummyOne} </div>
                                    </Row><br /><Row>
                                      <Col lg="4" md="4">
                                        <Form.Label style={{ paddingTop: "8px" }}>Dummy Two</Form.Label>
                                      </Col>
                                      <Col lg="8" md="8">
                                        <Form.Control type="text" onChange={this.handledummyTwoChange} className="form-control" name="dummyTwo" value={this.state.dummyTwo} required="required" placeholder="Enter Dummy Two" />
                                      </Col>
                                      <div className="errorMsg" style={{ color: "red" }}> {this.state.errors.dummyTwo} </div>
                                    </Row><br /><Row>
                                      <Col lg="4" md="4">
                                        <Form.Label style={{ paddingTop: "8px" }}>Dummy Three</Form.Label>
                                      </Col>
                                      <Col lg="8" md="8">
                                        <Form.Control type="text" onChange={this.handledummyThreeChange} className="form-control" name="dummyThree" value={this.state.dummyThree} required="required" placeholder="Enter Dummy Three" />
                                      </Col>
                                      <div className="errorMsg" style={{ color: "red" }}> {this.state.errors.dummyThree} </div>
                                    </Row><br /><Row>
                                      <Col lg="4" md="4">
                                        <Form.Label style={{ paddingTop: "8px" }}>Dummy Four</Form.Label>
                                      </Col>
                                      <Col lg="8" md="8">
                                        <Form.Control type="text" onChange={this.handledummyFourChange} className="form-control" name="dummyFour" value={this.state.dummyFour} required="required" placeholder="Enter Dummy Four" />
                                      </Col>
                                      <div className="errorMsg" style={{ color: "red" }}> {this.state.errors.dummyFour} </div>
                                    </Row><br /><Row>
                                      <Col lg="4" md="4">
                                        <Form.Label style={{ paddingTop: "8px" }}>Dummy Five </Form.Label>
                                      </Col>
                                      <Col lg="8" md="8">
                                        <Form.Control type="text" onChange={this.handledummyFiveChange} className="form-control" name="dummyFive" value={this.state.dummyFive} required="required" placeholder="Enter Dummy Five " />
                                      </Col>
                                      <div className="errorMsg" style={{ color: "red" }}> {this.state.errors.dummyFive} </div>
                                    </Row><br />
                                    {/* tableContent */}
                                  </Form>
                                </Row>
                              </Row>
                              <Row>
                                <Col
                                  className="d-flex justify-content-end"
                                  style={{ marginRight: "50px" }}
                                >
                                  <Button
                                    className="button"
                                    variant="success"
                                    onClick={this.BillupdateHandler}
                                    style={{
                                      marginTop: "20px",
                                    }}
                                  >
                                    Update
                                  </Button>
                                </Col>
                              </Row>
                            </Container>
                          </Offcanvas.Body>
                        </Offcanvas>
                      )}
                      {/*offcanvas is over */}
                    </Col>
                  </Row>
                  <br />
                  <Row>
                    <div style={{ "marginRight": "5px" }}>
                      {/* searchbar,pagination,filter */}
                      <input
                        type="text"
                        style={{ float: "left", marginBottom: "10px" }}
                        onChange={this.handleFilter}
                        placeholder="Search..."
                      />
                      <DataTable
                        data={paginatedData}
                        columns={this.state.tableClms}
                        pagination
                        paginationServer
                        paginationTotalRows={
                          this.state.filteredData
                            ? this.state.filteredData.length
                            : this.state.data.length
                        }
                        onChangeRowsPerPage={this.handlePerRowsChange}
                        onChangePage={this.handlePageChange}
                        paginationRowsPerPageOptions={[100, 200, 300, 400, 500, 600, 700, 800, 900, 1000]}
                        paginationPerPage={100}
                        keyField="id"
                        className="table table-striped table-bordered dataTable no-footer employeesTableIcons"
                      />
                    </div>
                  </Row>

                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

    );
  }
}
